export default "__VITE_ASSET__5bb445c7__"